import { ReactNode } from "react";
import { View } from "./View";

export interface ISectionHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  titleClassName?: string;
  subtitleClassName?: string;
  renderRight?: ReactNode;
}

export const SectionHeader = (props: ISectionHeaderProps) => {
  return <View {...props} />;
};
